export const PartneringController = {
    index(): void {},
};
